(function() {
    'use strict';
    angular
        .module('emarket.store')
        .controller('StoreController', ['$scope', '$log', '$rootScope', '$state', '$timeout', '$window', 'Auth', 'Announcer', 'Utils', 'profile', 'categories', function($scope,
            $log,
            $rootScope,
            $state,
            $timeout,
            $window,
            Auth,
            Announcer,
            Utils,
            profile,
            categories) {
            var vm = this;
            vm.store = profile;
            var announcer = Announcer.createEmitter();
            $timeout(function() {
                announcer.emit(Announcer.types.CHANGE_THEME_COLOR, '#05a5da');
            });
            vm.search = function() {
                $state.go('store.search', {
                    q: vm.q
                });
            };
            vm.categories = categories;
            $rootScope.config = $rootScope.config || {};
            if ($state.current.name === 'store.home') {
                $rootScope.config.sticky = true;
                $rootScope.config.compact = true;
            }
            vm.currentNavItem = $state.current.name;
            var ev = $rootScope.$on('$stateChangeSuccess', function(event, toState) {
                if (toState.name === 'store.home') {
                    $rootScope.config.sticky = true;
                    $rootScope.config.compact = true;
                } else {
                    $rootScope.config.sticky = false;
                    $rootScope.config.compact = false;
                }
                vm.currentNavItem = toState.name;
                $window.scrollTo(0, 0);
                Utils.blur('.store__header__search input');
            });
            $scope.$on('$destroy', function() {
                ev();
            });
        }]);
}());
